import { useState, useEffect } from "react";
import { MenuOverlay } from "./menuOverlay";
import { HowItWorksView } from "./howItWorksView";
import { FAQView } from "./faqView";

export const MenuView = ({ onOpen, onClose, forceClose, disabled }) => {
  const [menuState, setMenuState] = useState("none"); // "none" | "open" | "howItWorks" | "faq"

  useEffect(() => {
    if (forceClose) {
      setMenuState("none");
    }
  }, [forceClose])

  const handleOpen = (state) => {
    setMenuState(state);
    onOpen?.();
  }

  if (menuState === "howItWorks") {
    return <HowItWorksView onClose={() => handleOpen("open")} />;
  }

  if (menuState === "faq") {
    return <FAQView onClose={() => handleOpen("open")} />;
  }

  return (
    <MenuOverlay
      initialOpen={menuState === "open"}
      onOpen={() => handleOpen("open")}
      onClose={onClose}
      onHowItWorks={() => handleOpen("howItWorks")}
      onFaqs={() => handleOpen("faq")}
      onDownloadApp={() => {
        window.open("https://apps.apple.com/app/id6741884455", "_blank");
      }}
      disabled={disabled}
    />
  );
};